import { Box, Flex } from '@chakra-ui/react';
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { ButtonCustom } from '../UI';

export interface CaptchaRef {
  validateCaptcha: (input: string) => boolean;
  refreshCaptcha: () => void;
}

const Captcha = forwardRef<CaptchaRef>((props, ref) => {
  const [captchaText, setCaptchaText] = useState<string>('');
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const generateCaptcha = () => {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let text = '';
    for (let i = 0; i < 6; i++) {
      text += chars[Math.floor(Math.random() * chars.length)];
    }
    setCaptchaText(text);

    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        ctx.font = '30px Arial';
        ctx.fillStyle = '#fff';

        const textWidth = ctx.measureText(text).width;
        const canvasWidth = canvasRef.current.width;
        const textX = (canvasWidth - textWidth) / 2;
        const textY = 40;

        ctx.fillText(text, textX, textY);

        for (let i = 0; i < 20; i++) {
          ctx.beginPath();
          ctx.moveTo(
            Math.random() * canvasRef.current.width,
            Math.random() * canvasRef.current.height,
          );
          ctx.lineTo(
            Math.random() * canvasRef.current.width,
            Math.random() * canvasRef.current.height,
          );
          ctx.strokeStyle = '#aaa';
          ctx.stroke();
        }
      }
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  useImperativeHandle(ref, () => ({
    validateCaptcha(input: string) {
      return input === captchaText;
    },
    refreshCaptcha() {
      generateCaptcha();
    },
  }));

  return (
    <Flex mt={5} mb={2}>
      <Box background="#000">
        <canvas ref={canvasRef} width="184" height="64" />
      </Box>
      <ButtonCustom
        height="inherit"
        type="button"
        style={{ backgroundColor: '#f7f7f7' }}
        onClick={generateCaptcha}
      >
        ↻
      </ButtonCustom>
    </Flex>
  );
});

Captcha.displayName = 'Captcha';

export { Captcha };
